













































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import http from "../../service/data-service";
import DatePicker from "../../components/date-picker.vue";
import DeleteDialog from "../delete/DeleteDialog.vue";
import ConcursoMegaSena from "./ConcursoMegaSena.vue";
import { Form } from "../form";
import { requiredRule } from "../form-rules";
import NumberSelector from "../../components/number-selector.vue";
import concursoLotoMania from "./ConcursoLotoMania.vue";
import ConcursoLotoFacil from "./ConcursoLotoFacil.vue";
import ConcursoEstatisticas from "./ConcursoEstatisticas.vue";
import ConcursoQuina from "./ConcursoQuina.vue";
import ConcursoDuplaSena from "./ConcursoDuplaSena.vue";

@Component({
  components: {
    "date-picker": () => Promise.resolve(DatePicker),
    "concurso-megasena": () => Promise.resolve(ConcursoMegaSena),
    "concurso-dupla": () => Promise.resolve(ConcursoDuplaSena),
    "concurso-lotomania": () => Promise.resolve(concursoLotoMania),
    "concurso-lotofacil": () => Promise.resolve(ConcursoLotoFacil),
    "concurso-quina": () => Promise.resolve(ConcursoQuina),
    "number-selector": () => Promise.resolve(NumberSelector),
    "app-delete-dialog": () => Promise.resolve(DeleteDialog),
    "concurso-estatisticas": () => Promise.resolve(ConcursoEstatisticas),
  },
})
export default class Concurso extends Vue {
  form: Form = {
    valid: false,
    fields: {
      numero: 0,
      descricao: "",
      tipo: "",
      indicadorTipo: "",
      dataConcurso: "",
      dtProxConcurso: "",
    },
    rules: {
      numero: [requiredRule()],
      descricao: [requiredRule()],
      tipo: [requiredRule()],
      indicadorTipo: [requiredRule()],
      dataConcurso: [requiredRule()],
      dtProxConcurso: [requiredRule()],
    },
  };

  data: any = [];

  openEstatisticas: any = false;
  deleteDialog: any = false;
  selectedId: any = 0;
  vdt = "";
  headers = [
    { text: "Actions", value: "actions", sortable: false },
    {
      text: "Descrição",
      align: "start",
      value: "descricao",
    },
    {
      text: "Tipo",
      align: "start",
      value: "tipo",
    },
    {
      text: "Número",
      value: "numero",
    },
    {
      text: "Data",
      value: "dataConcurso",
    },
    {
      text: "Concurso",
      align: "start",
      value: "indicadorTipo",
    },
  ];

  tipos: any = [
    { value: "resultado", label: "Resultado" },
    { value: "estimativa", label: "Estimativa" },
  ];
  indicadorTipos: any = [
    { value: "megasena", label: "Mega Sena" },
    { value: "lotomania", label: "Loto Mania" },
    { value: "duplasena", label: "Dupla Sena" },
    { value: "quina", label: "Quina" },
    { value: "lotofacil", label: "Loto Fácil" },
  ];
  dialog: any = false;
  dialogConcurso: any = false;
  editedItem: any = {};
  concurso: any = {};
  _concurso: any = {};
  numberKey = 0;
  concursoKey = 0;
  concursoMsKey = 0;
  numberSelectorKey = 0;
  qtdeNumeros = 0;
  renderNumeros = false;
  alerts = false;
  alertKey = 0;
  alertError = "";
  dadosConcursoValidos = false;
  dataTableKey = 0;
  dtpProx = 0;
  dtpData = 0;
  loading = false;

  created() {
    this.init();
  }

  mounted() {
    console.log("asdfasdf");
  }

  load() {
    this.loading = true;
    http.get("/api/v1/concurso").then((value: any) => {
      this.dataTableKey += 1;
      this.data = value.data;
      for (var i = 0; i < this.data.length; i++) {
        if (value.data[i].concurso)
          if (value.data[i].indicadorTipo != "duplasena") {
            for (var n = 0; n < value.data[i].concurso.numeros.length; n++) {
              value.data[i].concurso.numeros[n] =
                value.data[i].concurso.numeros[n].numero;
            }
          } else {
            for (var n = 0; n < value.data[i].concurso.numeros1.length; n++) {
              value.data[i].concurso.numeros1[n] =
                value.data[i].concurso.numeros1[n].numero;
            }
            for (var n = 0; n < value.data[i].concurso.numeros2.length; n++) {
              value.data[i].concurso.numeros2[n] =
                value.data[i].concurso.numeros2[n].numero;
            }
          }
      }
      this.loading = false;
    });
  }

  init() {
    this.load();
    this.editedItem = {};
    const [year, month, day] = new Date()
      .toLocaleString()
      .substr(0, 10)
      .split("/");
    const newDate = `${day}-${month}-${year}`;
    this.editedItem.dataConcurso = newDate;
    this.editedItem.dtProxConcurso = newDate;

    console.log(this.editedItem.dataConcurso);
    console.log(this.editedItem.dtProxConcurso);
    this.dtpData += 1;
    this.dtpProx += 1;
    this.numberKey += 1;
    this.concurso = {};
    this.concurso.numeros = [];
    this.concurso.numeros1 = [];
    this.concurso.numeros2 = [];
  }

  incluir() {
    this.openEstatisticas = false;
    this.init();
  }

  importar() {
    this.loading = true;
    this.$store
      .dispatch("processarLotoFacil")
      .then((value) => {
        this.$store.dispatch("setNotification", {
          type: "info",
          text: "Loterias importadas com sucesso!",
        });
        this.init();
      })
      .catch((err) => {
        this.$store.dispatch("setNotification", {
          type: "error",
          text: "Ouve um erro ao consultar os boloes",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async editItem(item: any) {
    this.loading = true;
    let value = await http.get("/api/v1/concurso/findById/" + item.id);
    this.editedItem = { ...value.data };
    this.editedItem.dataConcurso = this.editedItem.dataConcurso.substr(0, 10);
    if (this.editedItem.dtProxConcurso) {
      this.editedItem.dtProxConcurso = this.editedItem.dtProxConcurso.substr(
        0,
        10
      );
    }
    this.dtpData += 1;
    this.dtpProx += 1;
    this.dialog = true;
    this.onChangeIndicadorTipo(this.editedItem.indicadorTipo);
    this.onChangeTipo(this.editedItem.tipo);
    if (this.editedItem.tipo == "resultado") {
      this.concurso = JSON.parse(JSON.stringify(this.editedItem.concurso));
      this._concurso = JSON.parse(JSON.stringify(this.editedItem.concurso));
    }
    var numeros: any = [];
    for (var i = 0; i < this.editedItem.concurso.numeros.length; i++) {
      numeros.push(this.editedItem.concurso.numeros[i].numero);
    }
    this.editedItem.concurso.numeros = numeros;
    this.numberSelectorKey += 1;
    this.loading = false;
  }

  onFocusOutNumero() {
    this.concursoKey += 1;
  }

  onChangeIndicadorTipo(value: any) {
    if (value != this.editedItem.indicadorTipo) {
      this.dadosConcursoValidos = false;
      this.concurso = {};
      this.concurso.numeros = [];
      this.concurso.numeros1 = [];
      this.concurso.numeros2 = [];
    }
    if (value == "megasena") {
      this.qtdeNumeros = 60;
    } else if (value == "lotomania") {
      this.qtdeNumeros = 100;
    } else if (value == "duplasena") {
      this.qtdeNumeros = 50;
    } else if (value == "quina") {
      this.qtdeNumeros = 80;
    } else if (value == "lotofacil") {
      this.qtdeNumeros = 25;
    }
    this.concursoMsKey += 1;
    this.numberKey += 1;
    this.concursoKey += 1;
  }

  formatDate(date: any) {
    if (!date) return null;

    const [year, month, day] = date.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
  }

  onChangeTipo(value: any) {
    this.renderNumeros = value == "resultado";
    this.concursoKey += 1;
  }

  async deleteItem(item: any) {
    this.selectedId = item.id;
    this.deleteDialog = true;
  }

  onConfirmDelete(event: any) {
    console.log("deletando");
    http.delete("/api/v1/concurso/delete/" + event).then((value: any) => {
      this.onCancelDelete();
      if (value.data.type == "ok") {
        this.$store.dispatch("setNotification", {
          type: "success",
          text: "Registro excluído com sucesso!",
        });
        this.load();
      } else {
        this.$store.dispatch("setNotification", {
          type: "error",
          text: value.data.msg,
        });
      }
    });
  }

  onCancelDelete() {
    this.selectedId = 0;
    this.deleteDialog = false;
  }

  onClose() {
    (this.$refs.form as Vue & { reset: () => void }).reset();
    this.onCloseConcurso();

    this.editedItem = {};
    this.dialog = false;
  }

  async onSave() {
    this.alertKey += 1;
    this.concursoKey += 1;
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (
        (this.dadosConcursoValidos && this.editedItem.tipo == "resultado") ||
        this.editedItem.tipo == "estimativa"
      ) {
        var data = await http.post("/api/v1/concurso/save/", this.editedItem);
        if (this.editedItem.indicadorTipo == "lotofacil") {
          this.openEstatisticas = true;
        }
        this.onClose();
        this.init();
      } else {
        this.alertError = "Informe os dados do concurso";
        this.alerts = true;
      }
    }
  }

  onAddDadosConcurso() {
    this.numberKey += 1;
    this.concursoKey += 1;
    if (this.editedItem.concurso) {
      this.concurso = this.editedItem.concurso;
    }

    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.dialogConcurso = !this.dialogConcurso;
    }
  }

  onSaveConcurso() {
    this.dialogConcurso = false;
    this.numberSelectorKey += 1;
    this.editedItem.concurso = this.concurso;
    this._concurso = JSON.parse(JSON.stringify(this.concurso));
    this.dadosConcursoValidos = true;
  }

  onCloseConcurso() {
    if (!this.editedItem.concurso) {
      this.concurso = {};
      this.concurso.numeros = [];
      this.concurso.numeros1 = [];
      this.concurso.numeros2 = [];
    } else {
      this.concurso = JSON.parse(JSON.stringify(this._concurso));
    }
  }
}
